import React from 'react'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Column, Text } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { useResponsiveLayout } from 'Hooks'

import { Content } from './styles'

function Title() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  return (
    <Column alignCenter={!isWideDesktop} fullWidth>
      <AppearingWrapper centered={!isWideDesktop} kind="expand">
        <Content flexDirection={!isWideDesktop ? 'column' : 'row'}>
          {StripedCircleSvg()}

          <Text
            accent
            as="h2"
            bold
            center={!isWideDesktop}
            screen24={!isDesktop}
            screen38={isDesktop}
          >
            WHY DO YOU NEED TO ACT NOW
          </Text>
        </Content>
      </AppearingWrapper>
    </Column>
  )
}

export default Title
